import { NavigationSelectionVariant } from '../../index';

export const NAVIGATION_TOKENS = {
  background: {
    default: '--navbar-main-default-bg',
    hover: '--navbar-main-default-bg_hover',
    active: '--navbar-main-selected-bg',
    activeHover: '--navbar-main-selected-bg_hover',
  },
  text: {
    default: '--navbar-main-default-text',
    hover: '--navbar-main-selected-text_hover',
    active: '--navbar-main-selected-text',
    activeHover: '--navbar-main-selected-text_hover',
  },
  icon: {
    default: '--navbar-main-default-icon',
    hover: '--navbar-main-default-icon_hover',
    active: '--navbar-main-selected-icon',
    activeHover: '--navbar-main-selected-icon_hover',
  },
  iconButton: {
    active: '--navbar-main-iconbutton-selected-bg',
  },
  border: {
    active: '--navbar-main-selected-border',
    activeHover: '--navbar-main-selected-border_hover',
  },
};

export const EXPANDED_SOLID_NAVIGATION_TOKENS = {
  background: {
    default: '--navbar-main-solid-expandable-default-bg',
    hover: '--navbar-main-solid-expandable-default-bg_hover',
    active: '--navbar-main-solid-expandable-selected-bg',
  },
  text: {
    default: '--navbar-main-solid-expandable-default-text',
    hover: '--navbar-main-solid-expandable-default-text_hover',
    active: '--navbar-main-solid-expandable-selected-text',
  },
  icon: {
    default: '--navbar-main-solid-expandable-default-icon',
    hover: '--navbar-main-solid-expandable-default-icon_hover',
  },
};

export const SUBNAVIGATION_TOKENS = {
  background: {
    hover: '--navbar-nested-default-bg_hover',
    active: '--navbar-nested-selected-bg',
    activeHover: '--navbar-nested-selected-bg_hover',
  },
  text: {
    default: '--navbar-nested-default-text',
    hover: '--navbar-nested-default-text_hover',
    active: '--navbar-nested-selected-text',
    activeHover: '--navbar-nested-selected-text_hover',
  },
};

// Direct way to extract navigation token values
const navigationTokenValues = Object.values(NAVIGATION_TOKENS).flatMap((category) =>
  Object.values(category),
);

// Direct way to extract subnavigation token values
const subnavigationTokenValues = Object.values(SUBNAVIGATION_TOKENS).flatMap((category) =>
  Object.values(category),
);

// Combined token values (if needed)
export const NAVIGATION_TOKENS_ARRAY = [...navigationTokenValues, ...subnavigationTokenValues];

type Tokens = Record<string, Record<string, string>>;

const appendVariantToTokens = (tokens: Tokens, variant: NavigationSelectionVariant): Tokens => {
  const result: Tokens = {};

  Object.entries(tokens).forEach(([category, values]) => {
    result[category] = {} as Record<string, string>;

    Object.entries(values).forEach(([tokenName, tokenValue]) => {
      result[category][tokenName] = `${tokenValue}-${variant}`;
    });
  });

  return result;
};

export const STROKE_NAVIGATION_TOKENS = appendVariantToTokens(
  NAVIGATION_TOKENS,
  NavigationSelectionVariant.Stroke,
);

export const SOLID_NAVIGATION_TOKENS = appendVariantToTokens(
  NAVIGATION_TOKENS,
  NavigationSelectionVariant.Solid,
);

export const getVariantNavigationTokens = (variant: NavigationSelectionVariant) => {
  return variant === NavigationSelectionVariant.Stroke
    ? STROKE_NAVIGATION_TOKENS
    : SOLID_NAVIGATION_TOKENS;
};
